// extracted by mini-css-extract-plugin
export default {"info":"AboutSkills_info__25iqY","logos":"AboutSkills_logos__ZJu23","logo":"AboutSkills_logo__tKq0C"};